const customFilterStyles = {
  SearchComponent: {
    width: "430px",
    maxWidth: "100% - 20%",
    //marginRight: "10px",
  },
  searchComponentContainer: {
    marginBottom: 2,
    marginLeft: "35px",
  },
  filterContainer: {
    display: "flex",
  },
};

export default customFilterStyles;
